module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-4.024a15ca.png";